import { Dtos, SuretyBondId } from "@inrev/common";
import { useMutation } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";

export const useRequestCloseBond = (suretyBondId: SuretyBondId) => {
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.SuretyBond.Close.Request): Promise<void> => {
			await post(`/v2/surety/bonds/${suretyBondId}/close/request`, data, "none");
		},
	});

	return { requestCloseBond: mutation.mutate, requestCloseBondLoading: mutation.isPending };
};
